import { useTranslation } from 'next-i18next'

import AuthGuard from '~/components/AuthGuard'
import Metatags from '~/components/Metadata/Metatags'
import ReferralPage from '~/components/Referral/ReferralPage'
import { DefaultLayout } from '~/shared/layouts'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'
import { usePageTitle } from '~/utils/tags'

export default function Referral(): React.ReactElement {
  const { t } = useTranslation('referral')
  const pageTitle = usePageTitle(t('referral'))

  return (
    <DefaultLayout hideAIButton zeroPadding>
      <Metatags noindex title={pageTitle} />
      <AuthGuard>
        <div className="flex min-h-screen h-full justify-center py-4 lg:pt-10 px-2">
          <ReferralPage />
        </div>
      </AuthGuard>
    </DefaultLayout>
  )
}

export const getProps: GetProps = () => () => {
  return {
    props: {
      namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'referral'],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)
